import React, { Component } from 'react';
import * as Sentry from '@sentry/browser';

class ErrorBoundry extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null
        };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({ error });
        Sentry.withScope(scope => {
            Object.keys(errorInfo).forEach(key => {
                scope.setExtra(key, errorInfo[key]);
            });
            Sentry.captureException(error);
        });
    }

    render() {
        if (this.state.error && this.props.subComponentDidMount) {
            //render fallback UI
            return (
                <div className="o-layout o-layout--center">
                    <div className="o-layout__item u-1/1@desktop">
                        <section className="o-max o-max--800">
                            <h2>Ugh Oh!</h2>
                            <p>Something went wrong when trying to display those events and the app has crashed.</p>
                            <p>Please try your query again.</p>
                            <button className="c-btn c-btn--red c-btn--small" onClick={() => Sentry.showReportDialog()}>Report error</button>
                        </section>
                    </div>
                </div>
            );
        } else {
            //when there's not an error, render children untouched
            return this.props.children;
        }
    }
}

export default ErrorBoundry



// WEBPACK FOOTER //
// ./src/whatson/components/ErrorBoundry.js